'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _EditCompanyByOwnerBranch = require('./EditCompanyByOwnerBranch.scss');var styles = _interopRequireWildcard(_EditCompanyByOwnerBranch);
var _index = require('../index');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
var EditCompanyByOwnerBranch = function (_Component) {_inherits(EditCompanyByOwnerBranch, _Component);function EditCompanyByOwnerBranch() {var _temp, _this, _ret;_classCallCheck(this, EditCompanyByOwnerBranch);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      addedBranch: false }, _this.






    renderField = function (_ref) {var input = _ref.input,_ref$meta = _ref.meta,touched = _ref$meta.touched,error = _ref$meta.error,active = _ref$meta.active,props = _objectWithoutProperties(_ref, ['input', 'meta']);return (
        _react2.default.createElement('div', { className: styles.content },
          _react2.default.createElement('div', { className: styles.title }, props.label, props.required ? _react2.default.createElement('span', { className: 'req' }, '*') : ''),
          _react2.default.createElement('label', null,
            _react2.default.createElement('input', _extends({ className: (0, _classnames2.default)('form-control', { 'has-error': error && !active && touched, touched: touched }) }, input)),
            touched &&
            error && _react2.default.createElement('span', { className: styles.required }, _this.props.translate('errorFieldMessages', 'required')))));}, _this.




    renderFieldWithLabel = function (name, placeholder, type, req, label) {return (
        _react2.default.createElement(_reduxForm.Field, {
          key: name,
          name: name,
          type: type || name,
          placeholder: placeholder || name,
          label: label || placeholder,
          required: req,
          component: _this.renderField }));}, _this.





















































    renderHideNumber = function (_ref2) {var input = _ref2.input;
      var inputLabel = _this.props.translate('publishProperty', 'hideHouseNumber');

      return (
        _react2.default.createElement('div', { className: styles.hideHouseNumber },
          _react2.default.createElement(_index.OMCheckbox, {
            id: 'hideHouseNumber_' + input.name,
            label: inputLabel,
            field: Object.assign({}, input, { checked: input.value }) })));



    }, _this.

    renderAddressCheckbox = function (branch) {return (
        _react2.default.createElement('div', { className: styles.addressCheckbox },
          _react2.default.createElement('div', null),
          _react2.default.createElement(_reduxForm.Field, {
            normalize: function normalize(currentValue) {return !!currentValue;},
            name: branch + '.hide_house_number',
            props: { locale: _this.props.locale },
            component: _this.renderHideNumber })));}, _this.




    renderBranch = function (branch, index, fields) {return (
        _react2.default.createElement('div', { className: styles.branches, key: branch + index },
          _react2.default.createElement('div', { className: styles.branch },
            !(fields.length === 1 && index === 0) &&
            _react2.default.createElement('div', { className: styles.wrapper },
              _react2.default.createElement('div', { className: styles.title },
                _this.props.translate('editOwner', 'branch'), ' ', index + 1),

              _this.renderFieldWithLabel(
              branch + '.name.he', '' +
              _this.props.translate('editOwner', 'hebrew'),
              'text',
              true, '' +
              _this.props.translate('editOwner', 'branchName'))),



            _react2.default.createElement('div', { className: styles.content },
              _react2.default.createElement('div', { className: styles.title },
                _this.props.translate('editOwner', 'address'),
                _react2.default.createElement('span', { className: 'req' }, '*')),

              _this.renderAddress(branch + '.address', index))),


          (index > 0 || index >= 1) &&
          _react2.default.createElement('div', { className: styles.deleteCurrentBranch, onClick: function onClick() {return fields.remove(index);} },
            _this.props.translate('editOwner', 'branchDelete'))));}, _this.





    renderBranches = function (_ref3) {var fields = _ref3.fields;
      var handleAddBranch = function handleAddBranch(evt) {
        evt.preventDefault();
        fields.push({});
        _this.setState({ addedBranch: true });
      };
      return (
        _react2.default.createElement('div', null,
          fields.map(function (branch, index, array) {return _this.renderBranch(branch, index, array);}),
          _react2.default.createElement('div', { className: styles.addBtnWrapper },
            _react2.default.createElement('button', { className: styles.addBtn, onClick: handleAddBranch }, '+ ',
              _this.props.translate('editOwner', 'addBranch')))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}EditCompanyByOwnerBranch.prototype.componentDidMount = function componentDidMount() {this.props.push('branches', {});};EditCompanyByOwnerBranch.prototype.renderAddress = function renderAddress(name, index) {var addedBranch = this.state.addedBranch;var _props = this.props,translate = _props.translate,isMobile = _props.isMobile,fields = _props.fields,locale = _props.locale,error = _props.error,anyTouched = _props.anyTouched,isRtl = _props.isRtl,reportIssue = _props.reportIssue,isAgent = _props.isAgent,token = _props.token,receiveGeocodedPlace = _props.receiveGeocodedPlace,geocodedPlace = _props.geocodedPlace,geocodeFailed = _props.geocodeFailed,changeValue = _props.changeValue;var parameters = { isMobile: isMobile, fields: fields, locale: locale, error: error, anyTouched: anyTouched, isRtl: isRtl, reportIssue: reportIssue };var isBranches = fields.branches[index] && Object.keys(fields.branches[index]).length > 0;var initialValues = !!(0, _get2.default)(this.props, 'initialValues');var companyId = !(0, _get2.default)(this.props, 'userData.data.agent_data.agency_id');if (companyId || initialValues && isBranches || addedBranch) {return _react2.default.createElement(_reactScroll.Element, { name: name, className: styles.addressWrapper }, _react2.default.createElement(_index.PublishAddressBlock, _extends({}, parameters, { translate: translate('publishProperty'), name: name, value: fields.branches[index] ? fields.branches[index].address : null, error: error && error.address, changeValue: changeValue, initialValue: fields.branches[index] ? fields.branches[index].address : {}, isRealtor: isAgent, receiveGeocodedPlace: receiveGeocodedPlace, geocodedPlace: geocodedPlace, geocodeFailed: geocodeFailed, isMobile: isMobile, token: token, className: styles.addressBlock, rootTranslate: this.props.translate })));}return null;};EditCompanyByOwnerBranch.prototype.

  render = function render() {
    return _react2.default.createElement(_reduxForm.FieldArray, { name: 'branches', component: this.renderBranches });
  };return EditCompanyByOwnerBranch;}(_react.Component);


EditCompanyByOwnerBranch.propTypes = {
  push: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isEditPage: _propTypes2.default.bool,
  isSingleBranch: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  fields: _propTypes2.default.object,
  error: _propTypes2.default.object,
  initialValues: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  anyTouched: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  changeValue: _propTypes2.default.func,
  receiveGeocodedPlace: _propTypes2.default.func,
  geocodedPlace: _propTypes2.default.object,
  userData: _propTypes2.default.object,
  geocodeFailed: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  reportIssue: _propTypes2.default.func };exports.default =


EditCompanyByOwnerBranch;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EditCompanyByOwnerBranch/EditCompanyByOwnerBranch.js
// module id = 2659
// module chunks = 0